<section [ngStyle]="tema == 'ROSA' ? {backgroundColor: 'var(--tema-rosa)'} : {backgroundColor: 'var(--cor-menu)'}">
  <div class="content-menu">
<!--    <div *ngIf="imagemUsuario == undefined; then defalut; else usuario" ></div>-->
    <ul>
      <li *ngFor="let item of menu">
        <div (click)="navegar(item.rota)"
             [ngStyle]=" tema == 'ROSA' ? {color: '#FFF'} : {color: '#bbb'}"
             [ngClass]="tema == 'ROSA' ? 'rosa-hover' : 'default-hover'"
        >
          <mat-icon aria-hidden="false" fontIcon="home">{{ item.icon }}</mat-icon> {{ item.nome }}
        </div>
      </li>
    </ul>
  </div>
    <span class="bottom-menu" (click)="logoutSistem()"
          [ngStyle]=" tema == 'ROSA' ? {color: '#FFF'} : {color: '#bbb'}"
          [ngClass]="tema == 'ROSA' ? 'rosa-hover' : 'default-hover'"
    >
        <mat-icon aria-hidden="false" aria-label="Example home icon" fontIcon="home">logout</mat-icon>
        <div class="logout">Sair</div>
    </span>
</section>

<ng-template #usuario>
    <img src="data:image/png;base64,{{imagemUsuario}}" alt="foto de perfil da pessoa" class="foto-perfil">
  </ng-template>
<ng-template #defalut>
    <img src="../../../assets/usuario.jpg" class="foto-perfil" alt="">
</ng-template>
